// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"83528c17","641":"5c24a5a9"}[chunkId] + ".chunk.js";
};